import { render, staticRenderFns } from "./BuddhaBoard.vue?vue&type=template&id=8739a7a6&scoped=true"
import script from "./BuddhaBoard.vue?vue&type=script&lang=js"
export * from "./BuddhaBoard.vue?vue&type=script&lang=js"
import style0 from "./BuddhaBoard.vue?vue&type=style&index=0&id=8739a7a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8739a7a6",
  null
  
)

export default component.exports